import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Locations } from '@type/locations';
import { RootState } from '@store/reducer';

export interface LocateState {
  locations: Locations;
}

export const initialState: LocateState = {
  locations: new Locations(),
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    getLocations: (state, { payload }: PayloadAction<Locations>) => {
      state.locations = new Locations(payload);
    },
  },
});

export const sliceActions = locationSlice.actions;
export const locationReducer = locationSlice.reducer;
export const locationSelector = (state: RootState) => state.location;
